//@flow
import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Dotdotdot from 'react-dotdotdot';
import type { VersionType } from 'types/product';
import { ProductAreaText } from 'components/atoms/productAreaText';
import bedRoomIcon from 'assets/images/bed.png';
import bathRoomIcon from 'assets/images/bathroom.png';
import { TabView } from 'components/atoms/tabView';
import { ShareButton } from 'components/atoms/shareButton';
import { CallToAction } from 'components/atoms/callToAction';
import './styles.scss';

type Props = {
  versions: Array<VersionType>,
  onClick: () => void,
  selectedVersion: VersionType,
};

export const FloorPlanInfo = (props: Props) => {
  const { versions, selectedVersion, onClick, type } = props;
  const productInfo = selectedVersion.product;
  const renderVersions = () => {
    return (
      <ul className={'tab-section'}>
        {versions &&
          versions.map((version, idx) => (
            <TabView
              data={{ name: version.name, id: version.id }}
              selectedId={selectedVersion.id}
              onClick={onClick}
              key={idx}
            />
          ))}
      </ul>
    );
  };
  return (
    <>
      <Row>
        <Col md={4} style={{ display: 'flex', alignItems: 'flex-end' }}>
          <h1>
            {productInfo.name}
            <h2 className={'product-version'}>{productInfo.version}</h2>
          </h1>
        </Col>
        {type !== 'Workcations' && (
          <Col md={8} className={'floor-version-section'}>
            <span>FloorPLAN VERSION</span>
            {renderVersions()}
          </Col>
        )}
      </Row>
      <Row>
        {type !== 'Workcations' && (
          <Col md={4}>
            <ProductAreaText
              data={{
                src: bedRoomIcon,
                value: `${productInfo.bedRooms} Bedrooms`,
                priority: 3,
              }}
            />
          </Col>
        )}
        {type !== 'Workcations' && (
          <Col md={8}>
            <ProductAreaText
              data={{
                src: bathRoomIcon,
                value: `${productInfo.bathRooms} Bathrooms`,
                priority: 3,
              }}
            />
          </Col>
        )}
        <Col md={8} style={{ paddingTop: '2%' }}>
          <span
            className={'variations-description'}
            dangerouslySetInnerHTML={{ __html: productInfo.description }}
          />
        </Col>
      </Row>
      <Row>
        {type !== 'Workcations' && (
          <Col md={4}>
            {selectedVersion.referenceSaleableArea &&
              selectedVersion.reference_saleable_area_label && (
                <ProductAreaText
                  data={{
                    text: `${selectedVersion.reference_saleable_area_label}`,
                    value: selectedVersion.referenceSaleableArea,
                    priority: 2,
                  }}
                />
              )}
          </Col>
        )}
        <Col md={8}>
          {selectedVersion.carpetArea && selectedVersion.carpet_area_label && (
            <ProductAreaText
              data={{
                text: `${selectedVersion.carpet_area_label}`,
                value: selectedVersion.carpetArea,
                priority: 2,
              }}
            />
          )}
        </Col>
        <Col md={4} style={{ marginTop: '4%' }}>
          {selectedVersion.saleableArea && selectedVersion.built_up_label && (
            <ProductAreaText
              data={{
                text: `${selectedVersion.built_up_label}`,
                value: selectedVersion.saleableArea,
                priority: 2,
              }}
            />
          )}
        </Col>
        <Col md={8} style={{ marginTop: '4%' }}>
          {selectedVersion.outdoorSpace && selectedVersion.outdoor_space_label && (
            <ProductAreaText
              data={{
                text: `${selectedVersion.outdoor_space_label}`,
                value: selectedVersion.outdoorSpace,
                priority: 2,
              }}
            />
          )}
        </Col>
      </Row>
    </>
  );
};
